import { render } from "./LinkageMailMagazineRescueProfile.vue?vue&type=template&id=d34fe156&ts=true"
import script from "./LinkageMailMagazineRescueProfile.vue?vue&type=script&lang=ts"
export * from "./LinkageMailMagazineRescueProfile.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1111083459/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__